import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import {EntityPaymentMethodContainerModel} from '../../../../../../models/aggregates/erp/entity';
import { EntityPaymentMethodCriteriaModelQuery, EntityPaymentMethodQueryCriteriaClass } from '../../../criteria/entity-payment-method-query-criteria.model';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';

@Injectable({providedIn: 'root'})
export class EntityPaymentMethodService extends BaseApiTemplateService<EntityPaymentMethodContainerModel> {

  readonly subUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-payment-methods';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.subUrl;
    this.endpoint_path = this.subUrl;
    this.httpClient = http;
  }

  getByCriteriaObservable(visa: ApiVisa, criteria?: EntityPaymentMethodQueryCriteriaClass): Observable<ApiResponseModel<EntityPaymentMethodContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildCriteria = new EntityPaymentMethodCriteriaModelQuery(criteria);
    return this.httpClient.get<ApiResponseModel<EntityPaymentMethodContainerModel>>(
      this.apiUrl + "/query?" + buildCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
